import axios from 'axios'

const authapi = axios.create({
  baseURL: process.env.AUTH_URL,
  validateStatus: function( status ) {
    return status >= 200 && status < 500;
  }
});


export default authapi



//////////////////
// WEBPACK FOOTER
// ./src/interceptors/authapi.js
// module id = null
// module chunks = 